import { Grid, Button } from "@material-ui/core";
import { FPaquetesStyle } from "./styles";
// import Origen from "./Origen";
import Destinos from "./Destinos";
import HeaderModal from "../../../global/headerModal";
// import IconButton from "@material-ui/core/IconButton";
// import EditIcon from "@material-ui/icons/Edit";
// import ExploreIcon from "@material-ui/icons/Explore";
import ModalBase from "./../../../global/ModalBase";
import { useDispatch, useSelector } from "react-redux";
import { closeModalCiudadesPaqueteTerrestre } from "../../../ducks/proveedorTerrestreDuck";
const FPaquetesDestinos = (props) => {

  const dispatch = useDispatch();
  const classes = FPaquetesStyle();
  const { paqueteSelect, openCiudadTerrestre } = useSelector(store => store.proveedorTerrestre);

  // const [isOrigen, setIsOrigen] = useState(true);
  // const handleChangeOrgien = () => {
  //   setIsOrigen(!isOrigen);
  // };
  const handleClose = () => {
    dispatch(closeModalCiudadesPaqueteTerrestre())
  };

  return (
    <ModalBase classes={classes} open={openCiudadTerrestre} onClose={handleClose}>
      {/* // TODO: Reemplazar en caso de que se quiera eliminar el modal de origen */}
      {/* <HeaderModal
        handleClose={handleClose}
        titulo={(paqueteSelect?.Origen && !isOrigen) ? `Destinos para el paqute ${paqueteSelect.Nombre}` : `Origen para el paqute ${paqueteSelect.Nombre}`}
      > */}
      <HeaderModal
        handleClose={handleClose}
        titulo={`Destinos para el paqute ${paqueteSelect?.Nombre}`}
      >
        <Grid container className={classes.containerSpacingLabel}>
          <Grid item xs={12}>
            {/* // TODO: Reemplazar en caso de que se quiera eliminar el modal de origen */}
            {/* {paqueteSelect.Origen || isOrigen ? ( */} 
              <div className={classes.flexSpacing}>
                {/* <h3>{`Origen: ${paqueteSelect?.Origen?.Nombre}`}</h3> */}
                {/* <IconButton
                  aria-label="closeModal"
                  onClick={handleChangeOrgien}
                >
                  {!isOrigen ? <EditIcon /> : <ExploreIcon />}
                </IconButton> */}
              </div>
            {/* ) : null} */}
          </Grid>
        </Grid>
      </HeaderModal>

      {/* // TODO: Reemplazar en caso de que se quiera eliminar el modal de origen */}
      {/* {!paqueteSelect.Origen || isOrigen ? (
        <Origen idPaquete={paqueteSelect.IdPaquete} setOpen={setOpen} setIsOrigen={setIsOrigen} />
      ) : ( */}
        <Destinos idPaquete={paqueteSelect?.IdPaquete} />
      {/* )} */}

      <Grid container className={classes.containerSpacing}>
        <Grid item xs={12} className={classes.modalBotonesCenter}>
          
          {/* // TODO: Reemplazar en caso de que se quiera eliminar el modal de origen */}
          {// (paqueteSelect.Origen && !isOrigen) &&          
            <Button
              onClick={handleClose}
              variant="contained"
              color="primary"
              className={classes.modalBoton}
            >
              Aplicar
            </Button>
          }

        </Grid>
      </Grid>
    </ModalBase>
  );
};
export default FPaquetesDestinos;
